export default __webpack_public_path__ + "static/media/R6No3.4e8879d2.mp3";